
import SebComponentBase from '../../shared/application/seb-component-base'
import SebStringTools from '../../shared/application/seb-string-tools'

import { Component } from 'vue-property-decorator'
import { sprintf } from 'sprintf-js'

@Component
export default class Notification extends SebComponentBase {
  public picker = null
  public countEvent = 0

  public refreshCount () {
    const d = new Date()
    const dateMonthInput = {
      year: d.getFullYear().toString(),
      month: (d.getMonth() + 1).toString(),
      day: d.getDate().toString(),
      sortBy: 'Start'
    }
    const queryString = SebStringTools.convertModelToQueryString(dateMonthInput)
    const requestUrl = sprintf(this.seb.apiRoutes.event.GetTodayCountEvents, queryString)
    this.getItem<void>(requestUrl, (result: any) => {
      this.countEvent = +result
    })
  }
}
